import { Routes, Route, Navigate } from "react-router-dom";
import RequireAuth from "./components/RequireAuth";
import Login from "./components/Login";
import NotFound from "./components/NotFound";
import Report from "./components/Report";
import ErrorPage from "./components/ErrorPage";
import Forbidden from "./components/Forbidden";
import NoPermission from "./components/NoPermission";
import useAuth from "./hooks/useAuth";
import Wrapper from "./Wrapper";

// reports
import GiftCardTransactionDetail from "./components/reports/GiftCardTransactionDetail/GiftCardTransactionDetail";
import ProgramSummaryDetail from "./components/reports/ProgramSummaryDetail/ProgramSummaryDetail";
import MerchantSettlementTransactionDetail from "./components/reports/MerchantTransactionDetail/MerchantTransactionDetail";
import TransactionSummary from "./components/reports/TransactionSummary/TransactionSummary";
import MasterCardSettlementReconciliation from "./components/reports/MasterCardSettlementReconciliation/MasterCardSettlementReconciliation";
import TrialBalanceHistoricalData from "./components/reports/TrialBalanceHistoricalData/TrialBalanceHistoricalData";
import VisaSettlementReconciliation from "./components/reports/VisaSettlementReconciliation/VisaSettlementReconciliation";
import CardDefundingTransactionDetail from "./components/reports/CardDefundingTransactionDetail/CardDefundingTransactionDetail";
import PulseSettlementReconciliation from "./components/reports/PulseSettlementReconciliation/PulseSettlementReconciliation";
import CardholderLiability from "./components/reports/CardholderLiability/CardholderLiability";
import MastercardFeeSummary from "./components/reports/MastercardFeeSummary/MastercardFeeSummary";
import CardholderFeeSummary from "./components/reports/CardholderFeeSummary/CardholderFeeSummary";
import CardAdjustment from "./components/reports/CardAdjustment/CardAdjustment";
import MonthlyDeclinedTransactions from "./components/reports/MonthlyDeclinedTransactions/MonthlyDeclinedTransactions";

import Dashboard from "./components/dashboard/Dashboard";
import MastercardInterchangeIncomeSummary from "./components/reports/MastercardInterchangeIncomeSummary/MastercardInterchangeIncomeSummary";
import CrossBinTransferSummary from "./components/reports/CrossBinTransferSummary/CrossBinTransferSummary";
import DeclinedAuthorizationRequest from "./components/reports/DeclinedAuthorizationRequest/DeclinedAuthorizationRequest";


const AppRoutes = () => {
  const { userName } = useAuth();

  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<Login />} />

      {/* App shell */}
      <Route path="/" element={<Wrapper />}>
        {/* Default route after login */}
        <Route
          index
          element={
            <RequireAuth>
              <Navigate to="reports/dashboard" replace />
            </RequireAuth>
          }
        />

        {/* Reports */}
        <Route path="reports" element={<Report />}>
          <Route
            index
            element={
              <RequireAuth>
                <Navigate to="dashboard" replace />
              </RequireAuth>
            }
          />

          <Route
            path="dashboard"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />

          <Route
            path="giftcardtransactiondetail"
            element={
              <RequireAuth requiredClaim="ViewGiftCardTransactionDetail">
                <GiftCardTransactionDetail />
              </RequireAuth>
            }
          />

          <Route
            path="programsummarydetail"
            element={
              <RequireAuth requiredClaim="ViewProgramSummary">
                <ProgramSummaryDetail />
              </RequireAuth>
            }
          />

          <Route
            path="merchanttransactiondetail/:category"
            element={
              <RequireAuth requiredClaim="ViewMerchantAuthorizationTransactionDetail">
                <MerchantSettlementTransactionDetail />
              </RequireAuth>
            }
          />

          <Route
            path="transactionsummary"
            element={
              <RequireAuth requiredClaim="ViewTransactionSummary">
                <TransactionSummary />
              </RequireAuth>
            }
          />

          <Route
            path="mastercardsettlementreconciliation"
            element={
              <RequireAuth requiredClaim="ViewMasterCardSettlementReconciliation">
                <MasterCardSettlementReconciliation />
              </RequireAuth>
            }
          />

          <Route
            path="visasettlementreconciliation"
            element={
              <RequireAuth requiredClaim="ViewVisaSettlementReconciliation">
                <VisaSettlementReconciliation />
              </RequireAuth>
            }
          />

          <Route
            path="trialbalancehistoricaldata"
            element={
              <RequireAuth requiredClaim="ViewTrialBalanceHistoricalData">
                <TrialBalanceHistoricalData />
              </RequireAuth>
            }
          />

          <Route
            path="carddefundingtransactiondetail"
            element={
              <RequireAuth requiredClaim="ViewCardDefundingTransactionDetail">
                <CardDefundingTransactionDetail />
              </RequireAuth>
            }
          />

          <Route
            path="pulsesettlementreconciliation"
            element={
              <RequireAuth requiredClaim="ViewPulseSettlementReconciliation">
                <PulseSettlementReconciliation />
              </RequireAuth>
            }
          />

          <Route
            path="cardholderliability"
            element={
              <RequireAuth requiredClaim="ViewCardholderLiability">
                <CardholderLiability />
              </RequireAuth>
            }
          />

          <Route
            path="mastercardfeesummary"
            element={
              <RequireAuth requiredClaim="ViewMasterCardFeeSummary">
                <MastercardFeeSummary />
              </RequireAuth>
            }
          />

          <Route
              path="mastercardinterchangeincomesummary"
              element={
                  <RequireAuth requiredClaim="ViewMastercardInterchangeIncomeSummary">
                      <MastercardInterchangeIncomeSummary />
                  </RequireAuth>
              }
          />

          <Route
              path="cardholderfeesummary"
              element={
                  <RequireAuth requiredClaim="ViewCardholderFeeSummary">
                      <CardholderFeeSummary />
                  </RequireAuth>
              }
          />
          <Route
              path="cardadjustment"
              element={
                  <RequireAuth requiredClaim="ViewCardAdjustment"> 
                      <CardAdjustment />
                  </RequireAuth>
              }
          />

          <Route
              path="CrossBinTransferSummary"
              element={
                  <RequireAuth requiredClaim="ViewCrossBinTransferSummary">
                      <CrossBinTransferSummary />
                  </RequireAuth>
              }
          />
          <Route
              path="DeclinedAuthorizationRequest"
              element={
                  <RequireAuth requiredClaim="ViewDeclinedAuthorizationRequest">
                      <DeclinedAuthorizationRequest />
                  </RequireAuth>
              }
          />

          <Route
              path="cardholderfeesummary"
              element={
                  <RequireAuth requiredClaim="ViewCardholderFeeSummary">
                      <CardholderFeeSummary />
                  </RequireAuth>
              }
          />
          <Route
              path="monthlydeclinedtransactions"
              element={
                  <RequireAuth requiredClaim="ViewMonthlyDeclinedTransactions">
                      <MonthlyDeclinedTransactions />
                  </RequireAuth>
              }
          />
        </Route>

        {/* Other routes */}
        <Route
          path="nopermission"
          element={<NoPermission userName={userName} />}
        />
        <Route path="error" element={<ErrorPage />} />
        <Route path="forbidden" element={<Forbidden />} />

        {/* Catch-all */}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;